// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpiredStep_wrapper__VcUUX","title":"ExpiredStep_title__VFaGw","text":"ExpiredStep_text__rXb5V"};